import { nameBrand } from '~/util/defaultInfo'

const defaultSeo = {
  h1: `Онлайн казино ${nameBrand}`,
  title: `Онлайн казино ${nameBrand}`,
  description: `Онлайн казино ${nameBrand}`,
  footer: [`Онлайн казино  ${nameBrand}`],
}

export const state = () => ({
  seoPage: {
    h1: `Онлайн казино ${nameBrand}`,
    title: `Онлайн казино ${nameBrand}`,
    description: `Онлайн казино ${nameBrand}`,
    footer: [`Онлайн казино ${nameBrand}`],
  },
  isFetchingContent: false,
})

export const mutations = {
  set_seoPage(state, data) {
    state.seoPage = data ? data : defaultSeo
  },
  set_FetchingContent(state, payload) {
    state.isFetchingContent = payload
  },
}

export const actions = {
  async fetch_seoPage({ commit }, params) {
    commit('set_FetchingContent', true)
    const res = await this.$api.seo.getSeo(params)
    if (!Object.keys(res.data || {}).length) {
      commit('set_seoPage', defaultSeo)
      return
    }
    commit('set_seoPage', res.data)
    commit('set_FetchingContent', false)
  },
}

export const getters = {
  get_seoPage: state => state.seoPage,
  get_isFetchingContent: state => state.isFetchingContent,
}
